import React from 'react'
import './LG.scss'

const Login = () => {
  return (
    <div className='container'>
        <div className="login_wrapper">
            <h1>login</h1>
            <form>
                <div className='input'>
                    <label htmlFor="email">Email</label>
                    <input type="email" id='email' />
                </div>
                <div className='input'>
                    <label htmlFor="password">Password</label>
                    <input type="email" id='email' />
                </div>
                <button>Login</button>
            </form>
        </div>
    </div>
  )
}

export default Login